// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__64UHZ","content":"Dialog_content__LsZUv"};